import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Linkedin } from "lucide-react";
import AshrenLogo from "@/components/AshrenLogo";

export default function Footer() {
  return (
    <footer className="bg-[color:var(--primary-dark)] text-white" data-testid="site-footer">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-14 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <AshrenLogo variant="light" className="h-14 w-auto" testId="footer-ashren-logo" />
          <p className="mt-6 text-white/70 max-w-md leading-relaxed">
            Canada&apos;s specialist staffing partner — from AI/ML engineers to frontline talent,
            delivered fast. Built on Canadian compliance, delivered coast-to-coast.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 text-white/60 text-sm">
            <span className="inline-block w-2 h-2 rounded-full bg-[color:var(--accent-mint)]" />
            Canadian compliance-first · WCB / PIPEDA / Law 25 fluent
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-display text-lg mb-4">Services</h4>
          <ul className="space-y-2 text-white/70">
            <li><Link to="/technology-staffing" className="hover:text-white" data-testid="footer-link-tech">Technology Staffing</Link></li>
            <li><Link to="/general-staffing" className="hover:text-white" data-testid="footer-link-general">General Staffing</Link></li>
            <li><Link to="/healthcare-staffing" className="hover:text-white" data-testid="footer-link-healthcare">Healthcare Staffing</Link></li>
            <li><Link to="/rpo" className="hover:text-white" data-testid="footer-link-rpo">RPO — Recruitment Outsourcing</Link></li>
            <li><Link to="/eor" className="hover:text-white" data-testid="footer-link-eor">EOR — Employer of Record</Link></li>
            <li><Link to="/for-employers" className="hover:text-white" data-testid="footer-link-employers">For Employers</Link></li>
            <li><Link to="/for-candidates" className="hover:text-white" data-testid="footer-link-candidates">For Candidates</Link></li>
            <li><Link to="/resources" className="hover:text-white" data-testid="footer-link-resources">Resources</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-display text-lg mb-4">Contact</h4>
          <ul className="space-y-3 text-white/70">
            <li className="flex gap-3">
              <MapPin size={18} className="mt-0.5 shrink-0 text-[color:var(--accent-amber)]" />
              <span>101, 2529 Kingsway<br />Vancouver, BC V5R 5H3<br />Canada</span>
            </li>
            <li className="flex gap-3 items-center">
              <Mail size={18} className="shrink-0 text-[color:var(--accent-teal)]" />
              <a href="mailto:Sales@ashrenltd.com" className="hover:text-white" data-testid="footer-email-link">Sales@ashrenltd.com</a>
            </li>
            <li className="flex gap-3 items-center">
              <Phone size={18} className="shrink-0 text-[color:var(--accent-purple)]" />
              <a href="tel:+12364850134" className="hover:text-white" data-testid="footer-phone-link">+1 236-485-0134</a>
            </li>
            <li className="flex gap-3 items-center">
              <Linkedin size={18} className="shrink-0 text-[color:var(--accent-mint)]" />
              <span className="text-white/50">ashrenltd.com</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-14 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-sm text-white/50">
          <p>© {new Date().getFullYear()} Ashren Consulting Ltd. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-link-privacy">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-link-terms">Terms of Use</Link>
            <Link to="/cookies" className="hover:text-white transition-colors" data-testid="footer-link-cookies">Cookie Policy</Link>
            <span className="text-white/30">·</span>
            <span>Made in Vancouver · Delivered across Canada</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
